import { jsxs, jsx } from 'react/jsx-runtime';
import { formatDisplay } from '../../../utils/number.esm.js';

const SliderTrackLabels = ({ min, max, className = "", minClassName = "", maxClassName = "", format = formatDisplay, }) => {
    return (jsxs("div", { className: className, "aria-hidden": "true", children: [jsx("span", { className: minClassName, children: format(min) }), jsx("span", { className: maxClassName, children: format(max) })] }));
};

export { SliderTrackLabels };
